import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Card, Row, Col, Form, Button, Spinner } from 'react-bootstrap'

import PasswordChecklist from '../../_Components/PasswordChecklist'
import { usersService } from '../../../../../_services/users.service'
import { alertActions } from '../../../../../_actions/alert.actions'
import httpStatus from 'http-status'

export default function ChangePassword({ user }) {
  const dispatch = useDispatch()

  const [isValid, setIsValid] = useState(true)
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  const [loading, setLoading] = useState(false)

  const handle = () => {
    setLoading(true)

    usersService.changePassword(user.userId, password)
      .then(() => {
        setPassword('')
        dispatch(alertActions.success('Password changed.'));
      })
      .catch(error => {
        if (error.response && error.response.status === httpStatus.UNPROCESSABLE_ENTITY) {
          dispatch(alertActions.error(error.response.data.message));
        } else {
          dispatch(alertActions.error('Could not change password at this time. Please try again.'));
        } 
      })
      .then(() => {
        setLoading(false)
      })
  }

  return (
    <Card className='border-0 axs-shadow p-3' style={{height: '300px', borderRadius: '16px'}}>
      <Card.Body className='d-flex flex-column justify-content-between'>
        <Row>
          <Col>
            <Row>
              <Col>Password</Col>
            </Row>
            <Row className='my-2'>
              <Col>
                <Form.Group controlId="formPassword">
                  <Form.Control 
                    value={password}
                    type={showPassword ? 'text' : "password"} 
                    onChange={(e) => setPassword(e.target.value)}
                    className='font-weight-light'
                    placeholder="Enter Password" 
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Check 
                  id="custom-password-switch"
                  type="switch"
                  label="Show Password"
                  onChange={() => setShowPassword(!showPassword)}
                />
              </Col>
            </Row>
          </Col>
          <Col className='text-muted'>
            <Row>
              <Col>
                <small>Password Requirements:</small>
              </Col>
            </Row>
            <Row>
              <Col>
                <PasswordChecklist password={password} setIsValid={(value) => setIsValid(value)}/>
              </Col>
            </Row>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs='6'>
            <Button disabled={!isValid || loading} block variant="success" onClick={handle}>
            { loading ? <Spinner size='sm' animation='border' /> : 'Change Password'}
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}
